import { Validator } from 'vee-validate';
import { DOCUMENT_LENGTH_WITH_MASK } from './constants/cpfCnpj';
import {
  isDifferenceDays,
  isEndDateSameOrAfter,
  isTodayLessOrSameThan,
  isMoreOrSameThanToday,
  isValidCellPhone,
  isValidDate,
} from './utils/customValidator';
import cpfCnpj from './services/cpfCnpj';

export default function setUpCustomValidations() {
  Validator.extend('cpfCnpj', {
    validate: (value) => {
      const cleanedValue = value.replace(/\D/g, '');
      return cpfCnpj.valida_cpf_cnpj(cleanedValue);
    },
    message: 'CPF ou CNPJ inválido',
  });
  Validator.extend('cpf_cnpj_min', {
    getMessage: (field) => {
      return `O campo ${field} deve possuir ${DOCUMENT_LENGTH_WITH_MASK.CPF} ou ${DOCUMENT_LENGTH_WITH_MASK.CNPJ} caracteres.`;
    },
    validate: (value) => {
      return (
        value.length === DOCUMENT_LENGTH_WITH_MASK.CPF ||
        value.length === DOCUMENT_LENGTH_WITH_MASK.CNPJ
      );
    },
  });
  Validator.extend('cellphone', {
    validate: (value) => isValidCellPhone(value),
    getMessage: () => 'Celular inválido',
  });
  Validator.extend('validDate', {
    getMessage: (field) => `O campo ${field} deve ser uma data válida`,
    validate: (value) => isValidDate(value),
  });
  Validator.extend('isTodayLessOrSameThan', {
    getMessage: (field) => `A ${field} não deve ser maior que a data atual`,
    validate: (value) => isTodayLessOrSameThan(value),
  });
  Validator.extend('isMoreOrSameThanToday', {
    getMessage: (field) => `A ${field} não deve ser anterior à data atual`,
    validate: (value) => isMoreOrSameThanToday(value),
  });
  Validator.extend('daysRange', {
    getMessage: (_, args) => {
      const [, maxDaysRange] = args;
      return `O periodo deve ser de no máximo ${maxDaysRange} dias`;
    },
    validate: (value, args) => {
      const [startDate, maxDaysRange] = args;
      return isDifferenceDays(startDate, value, maxDaysRange);
    },
  });
  Validator.extend('isEndDateSameOrAfter', {
    getMessage: () => `A data final deve ser maior que a data inicial`,
    validate: (value, args) => {
      const [startDate] = args;
      return isEndDateSameOrAfter(startDate, value);
    },
  });
}
